import { Paragraph } from '@zillow/constellation';
import { TermSetStatus, type UserStatus } from '../../../../../graphql/queries';
import { getIdentityExpirationDate, getIsIdentityVerified } from '../../../../../utils/user-statuses';
import { formatDate } from '../../../../../utils/formatters';
import { useApplicationContext } from '../../../../../contexts/ApplicationContext';

interface Props {
  applicationId: string;
  userStatuses: Array<UserStatus>;
}

export function IDVerificationOverview({ userStatuses }: Props) {
  const isIdentityVerified = getIsIdentityVerified(userStatuses);
  const identityExpirationDate = getIdentityExpirationDate(userStatuses);
  const { termSetStatus } = useApplicationContext();

  return isIdentityVerified ? (
    <>
      {termSetStatus === TermSetStatus.current ? (
        identityExpirationDate && (
          <Paragraph>Your identity verification is valid until {formatDate(identityExpirationDate)}</Paragraph>
        )
      ) : (
        <Paragraph>Updated terms available for acceptance</Paragraph>
      )}
    </>
  ) : null;
}
